import { render, staticRenderFns } from "./_infinite_multi_select.vue?vue&type=template&id=56b39e84&scoped=true&"
import script from "./_infinite_multi_select.vue?vue&type=script&lang=js&"
export * from "./_infinite_multi_select.vue?vue&type=script&lang=js&"
import style0 from "./_infinite_multi_select.vue?vue&type=style&index=0&id=56b39e84&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56b39e84",
  null
  
)

export default component.exports